export default __webpack_public_path__ + "c355b5d1fcce7d2172ee06bb7613c406.jpg";